const COMPONENT_NAME = "AddToList";
const BUTTON_COMPONENT_NAME = `${COMPONENT_NAME}Button`;
const DRAWER_COMPONENT_NAME = "Drawer";
const CLOSE_BUTTON_ID = "drawer-close-btn";
const TITLE_ID = "dialog-title";
const HEADER_ID = "drawer-header";
const addToListActions = {
  ADD_TO_LIST: "ADD_TO_LIST",
  CHANGE_LOADING_STATE: "CHANGE_LOADING_STATE",
  CHANGE_MODAL_STATE: "CHANGE_MODAL_STATE",
  CREATE_LIST: "CREATE_LIST",
  SET_SELECTED_LIST: "SET_SELECTED_LIST",
  SHOW_ERROR: "SHOW_ERROR",
  UPDATE_DRAWER_CONTENT: "UPDATE_DRAWER_CONTENT",
  UPDATE_NEW_LIST_NAME: "UPDATE_NEW_LIST_NAME",
  UPDATE_QUANTITY: "UPDATE_QUANTITY",
  UPDATE_SELECTED_LIST: "UPDATE_SELECTED_LIST",
  UPDATE_STATE: "UPDATE_STATE",
  UPDATE_WISH_LIST: "UPDATE_WISH_LIST",
  UPDATED_TO_LIST: "UPDATED_TO_LIST"
};
const CREATE_LIST_OPTION = "CREATE_LIST_OPTION";
const addToListInitialState = {
  addToListModalMode: addToListActions.ADD_TO_LIST,
  addToListModalOpen: false,
  clientIdLegacy: "",
  drawerContent: [],
  errorMsg: "",
  globalErrorMsg: "",
  globalSuccessMsg: "",
  hasInputError: false,
  inputErrorText: "",
  isLoading: false,
  newListName: "",
  productAttributes: [],
  quantity: "1",
  selectedList: "",
  selectedListId: "",
  selectedLists: [],
  showError: false,
  successMsg: "",
  wishList: [
    {
      text: "Create List",
      value: CREATE_LIST_OPTION
    }
  ],
  wishListFetched: false,
  wishLists: []
};
const defaultModalFooterButtonsLabels = {
  addItem: "Add item",
  cancel: "Cancel",
  continueShopping: "Continue Shopping",
  createList: "Create List",
  viewList: "View List"
};
const MAX_QUANTITY = 999;
const MODERN_ADD_TO_LIST_APIS_FEATURE_FLAG_DEV_KEY = "enable_add_to_list_modern_apis";
export {
  BUTTON_COMPONENT_NAME,
  CLOSE_BUTTON_ID,
  COMPONENT_NAME,
  CREATE_LIST_OPTION,
  DRAWER_COMPONENT_NAME,
  HEADER_ID,
  MAX_QUANTITY,
  MODERN_ADD_TO_LIST_APIS_FEATURE_FLAG_DEV_KEY,
  TITLE_ID,
  addToListActions,
  addToListInitialState,
  defaultModalFooterButtonsLabels
};
